import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, mdAndUp } = useDisplay();

const explains = ref([
  {
    number: "01",
    text: "순응도 및 몰입도 높은 UX/UI기반 음성언어 및 시선추적 데이터 수집 인공지능 모바일 플랫폼",
  },
  {
    number: "02",
    text: "단일 모바일 플랫폼을 통한 다중 생체신호 (음성언어 및 시선추적) 데이터 수집 플랫폼 개발",
  },
  {
    number: "03",
    text: "개인 모바일 기기를 통한 저비용, 고효율, 지속적, 비침습적 형태의 비대면 뇌건강 테스트를 돕는 게임 기술 개발",
  },
  {
    number: "04",
    text: "대화형 에이전트 기반을 통해 높은 사용자 경험, 몰입도로 정해진 데이터 수집 및 뇌건강 테스트를 할 수 있음",
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: _normalizeClass(["explains ma-3 mx-auto", { xs: _unref(xs), sm: _unref(sm) }]),
    justify: "center"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(explains.value, (explain, index) => {
        return (_openBlock(), _createBlock(_component_v_col, {
          cols: "6",
          md: "3",
          class: "explain",
          key: index
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "rounded-xl rounded-tr-0 px-0 py-4 ma-2",
              style: {"box-shadow":"0 2px 4px 0 #00000070"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  class: _normalizeClass(["justify-center font-weight-bold", { 'text-h6': _unref(xs), 'text-h6': _unref(sm), 'text-h5': _unref(mdAndUp) }]),
                  style: {"color":"#0a47ff"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(explain.number), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]),
                _createVNode(_component_v_card_text, {
                  class: _normalizeClass(["cardText text-center font-weight-medium", { 'xs py-2': _unref(xs), 'text-body-2': _unref(sm) }])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(explain.text), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})